import * as React from "react";
// import { graphql } from "gatsby";
import styled from "styled-components";
import PageContainer from "../../pageContainer";
import { GatsbyImage } from "gatsby-plugin-image";
import theme, { when } from "../../../styles/theme";
import { SectionTitle } from "../../typography";
import Link from "../../link.js";
import pageBackground from "../../../images/page_background_blue.jpg";
import { useLocalization } from "gatsby-theme-i18n";

const Wrapper = styled.section`
  background: ${(props) => props.theme.colors.darkBlue};
  position: relative;
`;

const ContainerBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  //z-index: -1;
  background-image: url(${pageBackground});
  background-repeat: repeat;
  background-position: center top;
`;

const BrandsSection = styled(PageContainer)`
  padding-top: 5rem;
  padding-bottom: 5rem;
  position: relative;
  z-index: 1;
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -${(props) => props.theme.gutterWidth.xs / 2}rem;

  ${when("sm")} {
    margin-left: -${(props) => props.theme.gutterWidth.sm / 2}rem;
    margin-right: -${(props) => props.theme.gutterWidth.sm / 2}rem;
  }

  ${when("md")} {
    margin-left: -${(props) => props.theme.gutterWidth.md / 2}rem;
    margin-right: -${(props) => props.theme.gutterWidth.md / 2}rem;
  }

  ${when("lg")} {
    margin-left: -${(props) => props.theme.gutterWidth.lg / 2}rem;
    margin-right: -${(props) => props.theme.gutterWidth.lg / 2}rem;
  }

  ${when("xl")} {
    margin-left: -${(props) => props.theme.gutterWidth.xl / 2}rem;
    margin-right: -${(props) => props.theme.gutterWidth.xl / 2}rem;
  }

  ${when("xxl")} {
    margin-left: -${(props) => props.theme.gutterWidth.xxl / 2}rem;
    margin-right: -${(props) => props.theme.gutterWidth.xxl / 2}rem;
  }
`;

const Title = styled(SectionTitle)`
  text-align: center;
`;

const Item = styled(Link)`
  padding: ${(props) => props.theme.gutterWidth.xs / 2}rem;
  width: 50%;
  display: block;

  &:first-child {
    width: 100%;
    margin-bottom: 3rem;
  }

  ${when("sm")} {
    width: 33.33%;
    padding: ${(props) => props.theme.gutterWidth.sm / 2}rem;
  }

  ${when("md")} {
    padding: ${(props) => props.theme.gutterWidth.md / 2}rem;

    &:first-child {
      width: 33.33%;
      align-self: center;
      margin-bottom: 0;
    }
  }

  ${when("lg")} {
    padding: ${(props) => props.theme.gutterWidth.lg / 2}rem;
  }

  ${when("xl")} {
    width: 25%;
    padding: ${(props) => props.theme.gutterWidth.xl / 2}rem;

    &:first-child {
      width: 25%;
    }
  }

  ${when("xxl")} {
    padding: ${(props) => props.theme.gutterWidth.xxl / 2}rem;
  }
`;

const Image = styled(GatsbyImage)`
  border-radius: 50%;
  width: 100%;
  transform: translateZ(0);
`;

const HomepageBrands = ({ data }) => {
  const { brands } = data;
  const { locale } = useLocalization();

  return (
    <Wrapper id='brands'>
      <ContainerBackground />
      <BrandsSection>
        <Container>
          <Item as={"div"}>
            <Title color={theme.colors.white}>{data.title}</Title>
          </Item>
          {brands.map((brand, index) => {
            const { largeLogo, name, slug } = brand;
            const url =
              locale === "en"
                ? `/en/restaurants/${slug}`
                : `/restaurants/${slug}`;

            if (largeLogo) {
              return (
                <Item key={index} href={url}>
                  <Image
                    alt={largeLogo.description}
                    image={largeLogo.gatsbyImageData}
                  />
                </Item>
              );
            }
            return null;
          })}
        </Container>
      </BrandsSection>
    </Wrapper>
  );
};

export default HomepageBrands;
